module.exports = function (app, mod, options) {
  var html;
  if (options.type === 'videocall') {
    html = "\n    <div id=\"screenrecord-wizard\" class=\"screenrecord-wizard\">\n      <h5 class=\"screenrecord-wizard-title\">What do you want to record?</h5>\n  ";
    html += "\n\t\t<div class=\"record-mode\">\n\t\t<div class=\"record-mode-option\" id=\"mode-audio\"><i  class=\" fa-solid fa-microphone-lines\"></i> </div>\n\t\t<div class=\"record-mode-option\" id=\"mode-video\" >  <i  class=\"fa-solid fa-tv \"></i> </div>\n\t\t</div>\n\t  ";
    html += "\n\t</div>\n\t";
  } else if (options.type === 'game') {
    html = "\n<div id=\"screenrecord-wizard\" class=\"screenrecord-wizard\">\n  <h5 class=\"screenrecord-wizard-title\">What do you want to record?</h5>\n";
    var video = document.querySelector('.saito-videobox');
    html += "\n\t<div class=\"record-mode\">\n\t".concat(!video ? '<div class="record-mode-option" id="mode-audio"><i  class=" fa-solid fa-tv"></i> <label>Screen only</label></div>' : '', "\n\t<div class=\"record-mode-option\" id=\"mode-video\" >  <i  class=\"fa-solid fa-camera \"></i><label>Screen + camera</label> </div>\n\t</div>\n  ");
    html += "\n</div>\n";
  } else {
    throw Error('No external media type selected');
  }
  return html;
};